const SPY_TESTER_DOMAINS = [
  "gol.in.cee-systems.com",
  "devel.golibe.com",
  "localhost",
];

const getHostname = (identifier: string | undefined): string => {
  if (!identifier) return "";

  try {
    return new URL(
      /^https?:\/\//i.test(identifier) ? identifier : `https://${identifier}`
    ).hostname.toLowerCase();
  } catch (_error) {
    return "";
  }
};

export const shouldEnableSpyTester = (
  ...identifiers: Array<string | undefined>
): boolean =>
  identifiers
    .map(getHostname)
    .some((hostname) =>
      SPY_TESTER_DOMAINS.some(
        (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
      )
    );
